import { render, staticRenderFns } from "./TrademarkObjectionToOpposingViewStatus.vue?vue&type=template&id=47705c34&"
import script from "./TrademarkObjectionToOpposingViewStatus.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToOpposingViewStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports